import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AccTeamFuncData } from '@interfaces';
import { AcceleratorAreaService } from 'pages/delivery/accelerator/accelerator-area.service';
import { AccCohortPageService, } from '../../../acc-cohort.page.service';
import { getSetup } from './grid/get-setup';

export interface AccTeam extends AccTeamFuncData {
	ventures: string | undefined,
	mentors: string | undefined,
}


@Component({
	selector: 'acc-teams-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './acc-teams-view.part.html',
})
export class AccTeamsViewPart {

	private readonly util = inject(UtilityService);
	private readonly dialogService = inject(DialogService);
	public readonly pageService = inject(AccCohortPageService);
	private readonly areaService = inject(AcceleratorAreaService);

	public setup = getSetup(this.util, this.dialogService, this.areaService);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public accTeams = computed<AccTeam[]>(() => {
		const data = this.areaService.data();
		const accTeamMap = this.areaService.accTeamMap();
		if (!data) return [];

		const mentorMap = data.mentors.reduce((map, m) => {
			const key = m.accTeamId;
			if (!map[key]) {
				map[key] = [];
			}
			map[key].push(m.fullName ?? `${m.firstName} ${m.lastName}`);
			return map;
		}, {} as Record<number, string[]>);

		return data.teams.map(t => ({
			...t,
			ventures: accTeamMap[t.accTeamId]?.ventures,
			mentors: mentorMap[t.accTeamId]?.join(', '),
		}));

	});

}